<h2 mat-dialog-title>{{ data.name | titlecase }}</h2>

<mat-dialog-content (contextmenu)="$event.preventDefault()">
  <div class="pdf-viewer" (contextmenu)="$event.preventDefault()">
    <div *ngIf="loading" class="loading" fxLayoutAlign="center center">
      <mat-spinner></mat-spinner>
    </div>

    <div *ngIf="error" class="error">{{ error }}</div>

    <div #pagesContainer class="pages-container"></div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close type="button">Close</button>
</mat-dialog-actions>
